import TVdxbApplicationInviteUserSummary from './index.vue';

TVdxbApplicationInviteUserSummary.install = app => {
  app.component(TVdxbApplicationInviteUserSummary.name, TVdxbApplicationInviteUserSummary);
};

export default TVdxbApplicationInviteUserSummary;
